import { IUserOrgsData } from './types';

const actions = {
  FETCH_USER_ORGS_REQUEST: 'ORG_SWITCHER_FETCH_USER_ORGS_REQUEST',
  FETCH_USER_ORGS_SUCCESS: 'ORG_SWITCHER_FETCH_USER_ORGS_SUCCESS',
  FETCH_USER_ORGS_ERROR: 'ORG_SWITCHER_FETCH_USER_ORGS_ERROR',

  fetchUserOrgs: () => ({ type: actions.FETCH_USER_ORGS_REQUEST }),
  fetchUserOrgsSuccess: (data: IUserOrgsData) => ({ type: actions.FETCH_USER_ORGS_SUCCESS, payload: data }),
  fetchUserOrgsError: (error: string) => ({ type: actions.FETCH_USER_ORGS_ERROR, payload: error }),
};

export default actions;
